import { Footer } from "rsuite";

export function FooterComponent() {
    return <>
        <div>Hola voy a ser un footer</div>
    </>
}